import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
  padding: 4rem;
`;

const Title = styled(motion.h1)`
  font-size: 4rem;
  font-weight: 700;
  color: #042E4B;
  margin-bottom: 4rem;
  text-align: center;
`;

const FoundersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  max-width: 1400px;
  width: 100%;
`;

const FounderCard = styled(motion.div)`
  background: white;
  border-radius: 24px;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-top: 5px solid #EF443C;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const PhotoCircle = styled.div`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 2rem;
  border: 5px solid #EF443C;
  box-shadow: 0 8px 24px rgba(239, 68, 60, 0.3);
  background: linear-gradient(135deg, #042E4B, #0A4A6F);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PhotoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FounderName = styled.h3`
  font-size: 1.6rem;
  color: #042E4B;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
  line-height: 1.3;
`;

const WebsiteLink = styled.a`
  font-size: 1.1rem;
  color: #EF443C;
  text-decoration: none;
  margin-bottom: 1.5rem;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Specialty = styled.div`
  font-size: 1.2rem;
  color: #607C90;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.5;
  font-weight: 500;
`;

const IconsRow = styled.div`
  display: flex;
  gap: 1rem;
  font-size: 1.8rem;
  margin-top: auto;
`;

const Slide12Fundadores: React.FC = () => {
  const founders = [
    {
      name: 'Gabriel Trevisani da Silva',
      photo: '/gab.jpeg',
      website: 'gab.dev.br',
      specialty: 'Negócio, Arquitetura e Desenvolvimento',
      icons: ['💼', '🏗️', '💻'],
    },
    {
      name: 'Mateus Vieira Murara',
      photo: '/mateus.png',
      website: null,
      specialty: 'Desenvolvedor Fullstack e Qualidade',
      icons: ['🔧', '✅'],
    },
    {
      name: 'Vinicius Vieira Murara',
      photo: '/vini.png',
      website: null,
      specialty: 'Desenvolvedor Fullstack e Negócio',
      icons: ['💻', '💼'],
    },
  ];

  return (
    <Container>
      <Title
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        Time Fundador ThinkWay
      </Title>

      <FoundersGrid>
        {founders.map((founder, index) => (
          <FounderCard
            key={`founder-${founder.name}`}
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              duration: 0.4,
              delay: 0.15 + index * 0.1,
              type: 'spring',
              stiffness: 80,
            }}
          >
            <PhotoCircle>
              <PhotoImage src={founder.photo} alt={founder.name} />
            </PhotoCircle>
            <FounderName>{founder.name}</FounderName>
            {founder.website && (
              <WebsiteLink href={`https://${founder.website}`} target="_blank" rel="noopener noreferrer">
                {founder.website}
              </WebsiteLink>
            )}
            <Specialty>{founder.specialty}</Specialty>
            <IconsRow>
              {founder.icons.map((icon, iconIndex) => (
                <span key={`icon-${index}-${iconIndex}`}>{icon}</span>
              ))}
            </IconsRow>
          </FounderCard>
        ))}
      </FoundersGrid>
    </Container>
  );
};

export default Slide12Fundadores;
